import { render, staticRenderFns } from "./distributionListFormatModal.vue?vue&type=template&id=3d9cb5d2&scoped=true"
import script from "./distributionListFormatModal.vue?vue&type=script&lang=js"
export * from "./distributionListFormatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9cb5d2",
  null
  
)

export default component.exports